import { RANGES } from '../constants';
import { applicationSettings } from '../settings/application';

export const dexfProdKeys = {
  aurdal: 'f0b44905-880e-4737-b252-f45dfe760ceb',
  boaxel: '9b8125dd-7d31-4a73-9a79-dcfd462bc749',
  bror: '7247c3db-9664-4fd1-a9eb-b4d90938a37f',
  elvarli: '411b3ce1-2f68-46e8-886f-4f08c63ecfcc',
  ivar: '285253d8-2ec3-4a18-84d7-42b1678607fe',
  jonaxel: '094b01b5-b441-4ed2-9142-1d84d47f8949',
};

export const dexfQaKey = {
  shared: '829e294e-1e25-4f81-975e-ad53ac4a3682',
};

export const getDexfApiKey = (range: string) => {
  if (!applicationSettings.isProd) return dexfQaKey.shared;

  switch (range) {
    case RANGES.AURDAL:
      return dexfProdKeys.aurdal;
    case RANGES.BOAXEL:
      return dexfProdKeys.boaxel;
    case RANGES.BROR:
      return dexfProdKeys.bror;
    case RANGES.ELVARLI:
      return dexfProdKeys.elvarli;
    case RANGES.IVAR:
      return dexfProdKeys.ivar;
    case RANGES.JONAXEL:
      return dexfProdKeys.jonaxel;
    default:
      throw new Error('Could not find dexf api key for range');
  }
};
